import React from "react";
import "../../MainDashboard/mainDashboard.css"
export const InsuranceFormSkeleton = () => {
  return (
    <div style={{ padding: "2rem" }}>
      {/* Stepper Skeleton */}
      <div style={{ display: "flex", justifyContent: "center", gap: "2rem", marginBottom: "2rem" }}>
        <div className="skeleton" style={{ width: "80px", height: "80px", borderRadius: "50%" }}></div>
        <div className="skeleton" style={{ width: "80px", height: "80px", borderRadius: "50%" }}></div>
      </div>

      {/* Form Section */}
      <div style={{ marginBottom: "2rem" }}>
        <div className="skeleton" style={{ width: "200px", height: "40px", marginBottom: "2rem" }}></div>

        {/* Two-column Form Row */}
        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
        </div>

        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
        </div>

        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
          <div className="skeleton" style={{ width: "100%", height: "40px" }}></div>
        </div>
      </div>

      {/* Upload Document Section */}
      <div>
        <div className="skeleton" style={{ width: "150px", height: "20px", marginBottom: "0.5rem" }}></div>
        <div className="skeleton" style={{ width: "100%", height: "50px" }}></div>
      </div>
    </div>
  );
};
